function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    // $("summary").attr("aria-expanded","false");
    // $("details").removeAttr('open');
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

       // stickyaddtocart
        console.log(this.currentVariant);
        if(this.currentVariant.compare_at_price != null && this.currentVariant.compare_at_price > this.currentVariant.price ){
            $('.product-sticky-atc-bar .price__sale .price-item--sale').html("₹ "+parseFloat(this.currentVariant.price/100));
            $('.product-sticky-atc-bar .price__sale .price-item--regular').html("₹ "+parseFloat(this.currentVariant.compare_at_price/100));
            $('.product-sticky-atc-bar .price.price--large').addClass('price--on-sale');
            $('.discount-badge span').html(Math.floor(100 - (this.currentVariant.price * 100) / this.currentVariant.compare_at_price) + "% off");
            $(".discount-badge").css({"display": "inline-block"});
          } else {
            $('.product-sticky-atc-bar .price__regular .price-item--regular').html('<span class="mrp">MRP:</span> ₹ '+parseFloat(this.currentVariant.price/100));
            $('.product-sticky-atc-bar .price.price--large').removeClass('price--on-sale');
            $(".discount-badge").css({"display": "none"});
          }
        if(this.currentVariant.featured_image != null && this.currentVariant.featured_image.src != ''){
          $('.product-sticky-atc-bar').find('.image img').attr('src',this.currentVariant.featured_image.src);
          $('.product-sticky-atc-bar').find('.image img').attr('srcset',this.currentVariant.featured_image.src);
        } else {
          $('.product-sticky-atc-bar').find('.image img').attr('src',$('.product-sticky-atc-bar').attr('featured_media'));
          $('.product-sticky-atc-bar').find('.image img').attr('srcset',$('.product-sticky-atc-bar').attr('featured_media'));
        }
      }); 
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);






$(document).ready(function(){  

  $('.announcement-bar-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 3000
  });

  $('.header-image-with-text-slider').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
    {
      breakpoint: 1281,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 1051,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 880,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 601,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 350,
      settings: {
        slidesToShow: 3
      }
    }
  ]
  });
  
    

  $('.icon-text-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: 'linear',
    responsive: [
    {
      breakpoint: 930,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 601,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
  });
  
  
  $('.image-with-text-custom-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true
  });
  
  
  $('.testimonial-slider').slick({
    centerMode: true,
    //slidesToShow: 3,
    variableWidth: true,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 1441,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 601,
        settings: {
          slidesToShow: 1
        }
      }
  ]
  });

  $('.about-us-accordion-slide').slick({
    centerMode: true,
    //slidesToShow: 3,
    variableWidth: true,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 1441,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 601,
        settings: {
          slidesToShow: 1
        }
      }
  ]
  });
  
  
  
  $('.instagram-gallery-slider').slick({
    centerMode: true,
    centerPadding: '150px',
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 1301,
        settings: {
          centerPadding: '100px'
        }
      },
      {
        breakpoint: 901,
        settings: {
          centerPadding: '100px',
          slidesToShow: 4,
        }
      },
      // {
      //   breakpoint: 750,
      //   settings: {
      //     slidesToShow: 4
      //   }
      // },
      {
        breakpoint: 601,
        settings: {
          centerPadding: '50px',
          slidesToShow: 2
        }
      }
  ]
  });
  
  
  
  $('.blog-posts-custom-slider').slick({
    centerMode: true,
    centerPadding: '200px',
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 1361,
        settings: {
          centerMode: false,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 750,
        settings: {
          centerMode: false,
          slidesToShow: 2
        }
      }
  ]
  });
  
  
  $('.home-collection-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    dots: false,
    // fade: true,
    onComplete:function(){
    $(".home-collection-slider").slick("refresh");
    },
    responsive: [
      {
        breakpoint: 1151,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 651,
        settings: {
          slidesToShow: 2
        }
      }
      // ,
      // {
      //   breakpoint: 356,
      //   settings: {
      //     slidesToShow: 1
      //   }
      // }
  ]
  });


  $('.image-over-text-slider').slick({
    // infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    speed: 500,
    fade: true,
    // cssEase: 'linear'
    responsive: [
      {
        breakpoint: 750,
        settings: {
          dots: true
        }
      },

  ]
  });


  $('.testimonials-content-slider').slick({
    centerMode: true,
    slidesToShow: 2,
    // variableWidth: true,
    slidesToScroll: 2,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 901,
        settings: {
          centerPadding: '150px',
          slidesToShow: 1
        }
      },
      {
        breakpoint: 750,
        settings: {
          centerPadding: '100px',
          slidesToShow: 1
        }
      },
      {
        breakpoint: 601,
        settings: {
          centerPadding: '50px',
          // variableWidth: true,
          slidesToShow: 1
        }
      },
      {
        breakpoint: 501,
        settings: {
          centerPadding: '40px',
          slidesToShow: 1
        }
      }
  ]
  });

  // $('.product-gallery-mobile-slider').slick({
  //   arrows: false,
  //   dots: true,
  //   responsive: [
  //     {
  //       breakpoint: 750,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //       }
  //     }
  // ]
  // });

});




$( document ).ready(function() {
  setTimeout(function () {
    $('.categories-name li:first-child a.categories-menus').trigger('click');
  }, 200);

  $( ".categories-name .categories-menus" ).click(function(e) {
    e.preventDefault();
    $('.home-collection-slider').slick('refresh');
    $( '.categories-name .categories-menus').removeClass('active');
    $( this ).addClass('active');
    var currentProduct = $( this ).attr('collection-id');
    var selectProduct = '[select-id="'+ currentProduct +'"]';

    $(".collections-block.categories").hide();
    $(selectProduct).fadeIn('fast');
    
    // $('.collections-block.categories').css({"display": "none"});
    // $(selectProduct).css({"opacity": "1", "z-index": "1"});
    
    // $('.collections-block.categories').css({"display": "none", "opacity": "0", "z-index": "-1"});
    // $(selectProduct).css({"display": "block", "opacity": "1", "z-index": "1"});
    // $(selectProduct).fadeIn('slow');

    // $('.collections-block.categories').css({"opacity": "0", "z-index": "-1"});
    // $(selectProduct).css({"opacity": "1", "z-index": "1"});

    // $('.collections-block.categories').removeClass('show-block');
    // $(selectProduct).addClass('show-block');

  });
});



// FIXED HEADER
// $(document).ready(function() {
//   window.onscroll = function() {myFunction()};

//   var HeaderHeight = $("#shopify-section-header").height()

//   var header = document.getElementById("shopify-section-header-image-with-text");
//   var sticky = header.offsetTop;

//   function myFunction() {

//     if (window.pageYOffset > sticky) {
//       header.classList.add("sticky");
//       $("#shopify-section-header-image-with-text.sticky").css("top", HeaderHeight);
//     } else {
//       header.classList.remove("sticky");
//     }
//   }
// });



// var lastScroll = 0;

// jQuery(document).ready(function($) {
//     $("#shopify-section-header-image-with-text").addClass("mobile");

//     $(window).scroll(function(){
//         var scroll = $(window).scrollTop();
//         if (scroll > lastScroll) {
//             $("#shopify-section-header-image-with-text").removeClass("mobile");
//         } else if (scroll < lastScroll) {
//             $("#shopify-section-header-image-with-text").addClass("mobile");
//         }
//         lastScroll = scroll;
//     });
// });












// Icon Block Expand Start
$(document).ready(function(){
  $(".icon-text-section .icon-block").click(function(){
  $( this ).toggleClass('active');
    $(".icon-text-section .icon-block").not($(this)).removeClass("active");
    
    var boxActiveCheck = false;
    $('.icon-text-section').find('.icon-block').each(function () {
      // console.log($(this).hasClass("active"));
      if($(this).hasClass("active")) {
        boxActiveCheck = true;
      }
    });
  
    if (boxActiveCheck){
      $(".icon-text-section .title").addClass('hide');
    } else {
      $(".icon-text-section .title").removeClass('hide');
    }
    
  });  
});
// Icon Block Expand End




// $(document).ready(function(){
//   $(".icon-text-section .content-block-one").click(function(){    
//     $( this ).toggleClass('active');
//     $(".icon-text-section .content-block-two").removeClass("active");
//     $(".icon-text-section .title").toggleClass('hide');
//   }); 

//   $(".icon-text-section .content-block-two").click(function(){    
//     $( this ).toggleClass('active');
//     $(".icon-text-section .content-block-one").removeClass("active");
//     $(".icon-text-section .title").toggleClass('hide');
//   }); 
// });



// AddtoCart Ajax Start 
function selectedVariant(data){
  var selected_variant_id = Number($(data).parents('.details').find('[name="product_id"]').val());
  $(data).parents('.details').find('[name="id"]').val(selected_variant_id);
  jQuery.getJSON(window.Shopify.routes.root + 'products/'+ $(data).attr('product-handle')+'.js', function(product) {
    $.each( product.variants, function( key, value ) {
      if($(data).val() == value.id) {
        if(value.available){
          $(data).parents('.details').find('.product-form__submit span').html("Add to cart");
          $(data).parents('.details').find('.product-form__submit').prop('disabled', false);
        }else{
          $(data).parents('.details').find('.product-form__submit span').html("Sold out");
          $(data).parents('.details').find('.product-form__submit').prop('disabled', true);
        }
      }
    });
  });
}

$("[select-variant]").change(function(){
  var data = $(this);
  var total = $(data).parents('.products').find('[select-variant]').length;
  var variantTitle = '';
  $(data).parents('.products').find('.product-form__submit').prop('disabled', true);
$(this).parents('.products').find('[select-variant]').each(function(index) {
  variantTitle += $(this).val();
    if (index === total - 1) {
        // this is the last one
    } else {
      variantTitle += " / ";
    }
});
  jQuery.getJSON(window.Shopify.routes.root + 'products/'+ $(this).attr('product-handle')+'.js', function(product) {
    // console.log(product);
    // console.log(product.variants);
    $.each(product.variants, function( index, value ) {
      if(variantTitle == value.title){
        if(value.id){
          if(value.compare_at_price != null){
            $(data).parents('.products').find('.price__sale .price-item--sale').text("₹ "+parseFloat(value.price/100));
            $(data).parents('.products').find('.price__sale .price-item--regular span').text("₹ "+parseFloat(value.compare_at_price/100));
            // $(data).parents('.products').find('.discount-badge span').text(Math.trunc(100 * (parseFloat(value.compare_at_price/100) - parseFloat(value.price/100)) / parseFloat(value.compare_at_price/100)) +"% off");
            if(value.compare_at_price >= value.price){
            $(data).parents('.products').find('.discount-badge span').html(Math.floor(100 - (value.price * 100) / value.compare_at_price) + "% off");
            $(data).parents('.products').find(".discount-badge").css({"display": "inline-block"});
            $(data).parents('.products').find('.discount-price span').html(Math.floor(100 - (value.price * 100) / value.compare_at_price) + "% Off");
            $(data).parents('.products').find(".discount-price").css({"display": "inline-block"});
            } else{
              $(data).parents('.products').find(".discount-badge").css({"display": "none"});
            }
              $(data).parents('.products').find(".price.price--large").addClass('price--on-sale');
          } else {
            $(data).parents('.products').find('.price__regular .price-item--regular').text("₹ "+parseFloat(value.price/100));
            $(data).parents('.products').find(".discount-badge").css({"display": "none"}); 
            $(data).parents('.products').find(".discount-price").css({"display": "none"}); 
            $(data).parents('.products').find(".price.price--large").removeClass('price--on-sale');
          }
          $(data).parents('.products').find('[name="id"]').val(value.id);
        }
        if(value.featured_image != null && value.featured_image.src != ''){
          $(data).parents('.products').find('.product-image img').attr('src',value.featured_image.src+'&width=400');
          // $(data).parents('.products').find('.product-image img').attr('srcset',value.featured_image.src+'&width=400');
        } else {
          $(data).parents('.products').find('.product-image img').attr('src',product.featured_image);
          // $(data).parents('.products').find('.product-image img').attr('srcset',product.featured_image);
        }
        if(value.available){
          $(data).parents('.products').find('.product-form__submit span').html("Add to cart");
          $(data).parents('.products').find('.product-form__submit').prop('disabled', false);
        } else {
          $(data).parents('.products').find('.product-form__submit span').html("Sold out");
          $(data).parents('.products').find('.product-form__submit').prop('disabled', true);
        }
      }
    });
  });
});


// AddtoCart Ajax End 



// collection page scorll smooth
$(document).on('click', '.template-collection a[href^="#"]', function (event) {
  event.preventDefault();

  $('html, body').animate({
    scrollTop: $($.attr(this, 'href')).offset().top
  }, 1000);
});






$(document).ready(function() {
  $("#accordion").find(".accordion-toggle").click(function() {
    $(this).next().slideToggle("slow"),
      $(this).toggleClass("active"),
      $(".accordion-content").not($(this).next()).slideUp("slow"),
      $(".accordion-toggle").not($(this)).removeClass("active")
  })

   $("#accordion-pro").find(".accordion-toggle").click(function() {
    $(this).next().slideToggle("slow"),
      $(this).toggleClass("active"),
      $(".accordion-content").not($(this).next()).slideUp("slow"),
      $(".accordion-toggle").not($(this)).removeClass("active")
  })
})

$(document).ready(function() {
  $("#accordion .accordion-section:first-child .accordion-toggle").addClass("active"),
  $("#accordion .accordion-section:first-child .accordion-content").css("display", "block")

  $("#accordion-pro .accordion-section:first-child .accordion-toggle").addClass("active"),
  $("#accordion-pro .accordion-section:first-child .accordion-content").css("display", "block")
})


$("#ingredients-accordion").find(".accordion-toggle").click(function() {
  $(this).next().slideToggle("slow"),
  $(this).toggleClass("active"),
  $(".accordion-content").not($(this).next()).slideUp("slow"),
  $(".accordion-toggle").not($(this)).removeClass("active")
})



// $( document ).ready(function() {
//       $( '.faq_1 .accordion-qus' ).next( ".accordion-ans" ).addClass("accordion_active");
//       $( '.faq_1 .accordion-qus' ).addClass("accordion_qus_active");
      
//       $(".accordion-type1 .accordion-qus").click(function() {
//         if($( this ).next( ".accordion-ans" ).hasClass("accordion_active")) {
//           $( this ).next( ".accordion-ans" ).removeClass("accordion_active");
//           $( this ).removeClass("accordion_qus_active");
//         } else {
//           $( ".accordion-type1 .accordion-ans" ).removeClass("accordion_active");
//           $( ".accordion-type1 .accordion-qus" ).removeClass("accordion_qus_active");
//           $( this ).next( ".accordion-ans" ).addClass("accordion_active");
//           $( this ).addClass("accordion_qus_active");
//         }
//       });
//     });




$(document).ready(function() {
    if (window.innerWidth <= 749) var t = 180;
    else t = 180;
    $(".meta-description p").each(function() {
        var e = $(this).html();
        if (e.length > t) {
            var i = e.substr(0, t) + '<span class="morecontent"><span>' + e.substr(t, e.length - t) + '</span>&nbsp;<a href="" class="morelink">... show more</a></span>';
            $(this).html(i)
        }
    }), $(".morelink").click(function() {
      // return $(this).hasClass("less") ? ($(this).removeClass("less"), $(this).html("... show more")) : ($(this).addClass("less"), $(this).html("show less")), $(this).parent().prev().toggle(), $(this).prev().toggle(), !1
     return $(this).hasClass("less") ? ($(this).removeClass("less"), $(this).html("... show more")) : ($(this).addClass("less"), $(this).html("show less")), $(this).parent().prev().toggle(), $(this).prev().toggleClass("show-content"), !1
    
    })
})

$(document).ready(function(){
  $('.tabs-nav a').on('click', function (event) {
    event.preventDefault();

    $('.tab-active').removeClass('tab-active');
    // $(this).parent().addClass('tab-active');
    $(this).addClass('tab-active');
    $('.tabs-stage .tab-block').hide();
    $($(this).attr('href')).show();
  });

  $('.tabs-nav a:first').trigger('click');
});

// $('.tabs-nav').slick({
//   dots: false,
//   arrows: true,
//   center: true,
//   infinite: false,
//   slidesToShow: 4,
//   responsive: [
//     {
//       breakpoint: 501,
//       settings: {
//         arrows: false,
//         slidesToShow: 3,
//         slidesToScroll: 1,
//       }
//     }
//   ]
// });

//========= sticky atc bar =========//
    // sticky
var lastScroll = 0;
    $(window).bind("scroll", function () {
      var st = $(this).scrollTop();
      var headerHeight = $('#shopify-section-header').outerHeight();
      var headerPosition = $('#shopify-section-header').offset().top + $('#shopify-section-header').outerHeight() - $(window).scrollTop();
      var atcPosition = $('.template-product .quantity-add-to-cart .product-form__submit').offset().top + $('.template-product .quantity-add-to-cart .product-form__submit').outerHeight();

      if (st > lastScroll){
        if ($(window).scrollTop() > atcPosition) {
          $(".template-product .product-sticky-atc-bar").addClass("active");
          $("body").addClass("remove-shadow");
          $(".template-product .product-sticky-atc-bar").css('top', headerPosition);
        } else {
          $(".template-product .product-sticky-atc-bar").removeClass("active");
          $("body").removeClass("remove-shadow");
          $(".template-product .product-sticky-atc-bar").css('top', '');
        }
      } else {
        if ($(window).scrollTop() + headerHeight > atcPosition) {
          $(".template-product .product-sticky-atc-bar").addClass("active");
          $("body").addClass("remove-shadow");
          $(".template-product .product-sticky-atc-bar").css('top', headerPosition);
        } else {
          $(".template-product .product-sticky-atc-bar").removeClass("active");
          $("body").removeClass("remove-shadow");
          $(".template-product .product-sticky-atc-bar").css('top', '');
        }
      }
      lastScroll = st;
    });


    
    $('.template-product .product-sticky-atc-bar').on('click', '.atc-btn', function () {
      $('.template-product .quantity-add-to-cart .product-form__submit').trigger('click');
    });
    //========= end sticky atc bar =========//



$(function(){
      $("#newmenu").on("click",function(){
        console.log("clicked")
        $(".nm-container").toggleClass("nm-active");
        $(this).toggleClass("open");
        $("body").toggleClass("fixit");
        $(".overlay").toggleClass("open");
        $(".mobile_close").toggleClass("open");
      })
    })
    
    $(function(){
      $(".overlay").on("click",function(){
        $(".nm-container").removeClass("nm-active");
        $("#newmenu").removeClass("open");
        $("body").removeClass("fixit");
        $(".overlay").removeClass("open");
        $(".mobile_close").removeClass("open");
      })
    })
    
    $(function(){
      $(".mobile_close").on("click",function(){
        $(".nm-container").removeClass("nm-active");
        $("#newmenu").removeClass("open");
        $("body").removeClass("fixit");
        $(".overlay").removeClass("open");
        $(".mobile_close").removeClass("open");
      })
    })


//outer click popup close:
$(document).click(function(e){
   var click=$(e.target);
   var outsideDiv=$(".nm-body").parents();
   if(click.is(outsideDiv) || click.is(".mobile_close")){
        $(".nm-container").removeClass("nm-active");
        $("#newmenu").removeClass("open");
        $("body").removeClass("fixit");
        $(".overlay").removeClass("open");
        $(".mobile_close").removeClass("open");
   }
});


// alternate-collection-buttons section
 $('.buttons-block-image-with-text-slider').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
    {
      breakpoint: 1281,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 1051,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 880,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 601,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 350,
      settings: {
        slidesToShow: 3
      }
    }
  ]
  });



// section: multicolumn slider custom

 $('.multicolumn__slide__container_customwise').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
    {
      breakpoint: 1026,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 601,
      settings: {
        slidesToShow: 1
      }
    },
    {
      breakpoint: 350,
      settings: {
        slidesToShow: 1
      }
    }
  ]
  });

// rich-text-custom-extend Section

$(document).ready(function() {
 $("#rich-text__text #content").append("<a href='#more-content' class='read-more'>Read more</a>");
  var paragraphCount = 1; 

  $('#rich-text__text #content p:lt(' + paragraphCount + ')').addClass('visible');

  $('#rich-text__text #content .read-more').click(function() {
    if ($('#rich-text__text #content .read-more').text() == "Read more") {
    $(this).text("Read less");
    $('#rich-text__text #content p').addClass('visible');
  } else {
    $(this).text("Read more");
    $('#rich-text__text #content p').removeClass('visible');
  $('#rich-text__text #content p:lt(' + paragraphCount + ')').addClass('visible');
  }
  });
});


$(document).ready(function(){ 
  $('.banner-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 500,
  });
});






















// $( document ).ready(function() {

//   $('.added-product-block .added-product .product-item:first-child').addClass('item-active');
  
//   var getPrice = [];

// $(".colection-product .add-btn").on("click", function() {
//     var variantId = $(this).attr('variant');
//     var image = $(this).attr('image-url');
//     var currentTag = $(this);
//     $(currentTag).parents('.addtocart-collection-bundle').find('.alert-msg').html('<p class="loading">Loading...</p>');
//     selectedVariant(currentTag, variantId);
    
//     if ($(this).text() == 'Add To Box') {
//         $(this).text('Remove Item');
//         // $(this).text('Added');
//         $(this).addClass("selected");
//     } else {
//         $(this).text('Add To Box');
//         $(this).removeClass("selected");
        
//         // // Filter out the deselected item
//         getPrice = getPrice.filter((product) => {
//             return product.selectVariantId != variantId;
//         });

//         // var removeTopBar = $('.added-product-block .add-image svg[variant="' + variantId + '"]');
        
//         // if (removeTopBar) {
//         //   $('.added-product-block .add-image svg').trigger('click');
//         // }


//        // Filter out the deselected item from getPrice
//         // getPrice = getPrice.filter(product => product.selectVariantId != variantId);
      
//         // Find the specific SVG element for this variant and trigger its click event
//         var removeTopBar = $('.added-product-block .add-image svg[variant="' + variantId + '"]');
        
//         if (removeTopBar.length) {
//           removeTopBar.trigger('click');
//         } else {
//           console.warn("No matching SVG element found for variant:", variantId);
//         }   

//         // console.log(getPrice, 'Updated getPrice after removing item');
//     }

//     var ProCount = $('#collection-bundle-product').attr('bundle-limit');

//     var SelectedProductCount = 0;
//     var AllSelectedProduct = $('.addtocart-collection-bundle .selected');
//     if (AllSelectedProduct.length > 0) {
//         SelectedProductCount = AllSelectedProduct.length;
//     } else {
//         SelectedProductCount = 0;
//     }



//     if(ProCount == SelectedProductCount) {
//        $(`.addtocart-collection-bundle .add-btn`).prop('disabled',true);
//        $(`.addtocart-collection-bundle .add-btn.selected`).prop('disabled',false);
//       } else {
//         $(`.addtocart-collection-bundle .add-btn`).prop('disabled',false);
//       }
  
  

//     var AllSelectedProductPrice = $(this).hasClass('selected') ? $(this).attr("price") : null;

//     if (AllSelectedProductPrice) {
//         getPrice.push({'selectVariantId': variantId, 'price': parseFloat(AllSelectedProductPrice), 'image_url': image});
//     }
    
//     // console.log(getPrice, 'getPrice');

//     // Calculate the total price
//     var totalprice = getPrice.reduce((total, product) => {
//         return total + Math.round(product.price);
//     }, 0);

//     // console.log(totalprice, 'totalprice');
//     // console.log(image,'image')

  
//     // if(image) {
//     //   $('.added-product-block .empty-image').css('display','none');
//     //   $('.added-product-block .add-image').css('display','block');
//     // } else {
//     //   $('.added-product-block .empty-image').css('display','inline-flex');
//     //   $('.added-product-block .add-image').css('display','none');
//     // }

//   //   getPrice.each((index,item) =>{
//   // $(".added-product-block .product-item ").eq(index).find('.add-image img').attr("src", item.image_url);
//   //     console.log(item,'item')
//   //   })

//   $(".added-product-block .product-item").removeClass('item-active');
  
//   getPrice.forEach((item, index) => {
//     $(".added-product-block .product-item").eq(index).removeClass('item-active');
//     $(".added-product-block .product-item").eq(index).find('.add-image').css('display','block');
//     $(".added-product-block .product-item").eq(index).find('.add-image').siblings('.empty-image').css('display','none');
//     $(".added-product-block .product-item").eq(index).find('.add-image img').attr("src", item.image_url);
//     $(".added-product-block .product-item").eq(index).find('.add-image svg').attr("variant", item.selectVariantId);
//     // .attr( { title:"Test", alt:"Test2" } );
//     console.log(item, 'item--1');
//   });

//   $(".added-product-block .product-item").eq(getPrice.length).addClass('item-active');
//       // .add-image img
//       // .attr("src", image);

//   $('.selected-pro-price .bundle-price span').text(totalprice);
  
//   // Get the values as numbers
//   var selectedProPrice = parseFloat($('.selected-pro-price .bundle-price span').text()) || 0;
//   var stickyBarPrice = parseFloat($('.selected-pro-price .total-price span').text()) || 0;
  
//   // Calculate the savings and update the element
//   var savings = selectedProPrice - stickyBarPrice;
//   $('.save-price p span').text(savings); // Format to 2 decimal places if necessary

//     // Update selected product count in the DOM
//     $('.add-collection-bundle .selected-pro-count span.selected-product-count').text(SelectedProductCount);

// });



// // Close Remove product 
// // $(".added-product-block .add-image svg").on("click", function() {
// //   var removeVariantId = $(this).attr('variant');
// // console.log('remove');
// //   getPrice = getPrice.filter((product) => {
// //     return product.selectVariantId != removeVariantId;
// //   });
// //   alert($('.collection-block .products .addtocart-collection-bundle button[variant="'+ removeVariantId +'"]'));

// //   $('.collection-block .products .addtocart-collection-bundle button[variant="'+ removeVariantId +'"]').removeClass("selected");

// //   $(this).parents('.add-image').css('display','none');
// //   $(this).parents('.add-image').siblings('.empty-image').css('display','inline-flex');


// //   getPrice.forEach((item, index) => {
// //     $(".added-product-block .product-item").eq(index).find('.add-image').css('display','block');
// //     $(".added-product-block .product-item").eq(index).find('.add-image').siblings('.empty-image').css('display','none');
// //     $(".added-product-block .product-item").eq(index).find('.add-image img').attr("src", item.image_url);
// //     $(".added-product-block .product-item").eq(index).find('.add-image svg').attr("variant", item.selectVariantId);
// //     console.log(item, 'item--2');
// //   });

// //   console.log(getPrice,'getPrice-new')
  

// // });



// function checkLimit() {
//    var checkCount = [];
//    var bundleLimit = $('#collection-bundle-product').attr('bundle-limit');
  
//    let bundleCount  = 0;
//    let all_quantities = $(".addtocart-collection-bundle .selected");

//    if(all_quantities.length > 0){
//      $(all_quantities).each(function(){
//        bundleCount = all_quantities.length;
//      });
//    }else{
//      bundleCount  = 0;
//  }

//   if(bundleLimit <= bundleCount) {
//     $('#collection-bundle-product-top').prop('disabled',false);
//      $('#collection-bundle-product').prop('disabled',false);
//      $('.add-collection-bundle .inner .price-atc-button .selected-pro-price .bundle-price').css('display','block');
//      $('.add-collection-bundle .inner .price-atc-button .save-price').css('display','block');
//    } else {
//     $('#collection-bundle-product-top').prop('disabled',true);
//      $('#collection-bundle-product').prop('disabled',true);
//      $('.add-collection-bundle .inner .price-atc-button .selected-pro-price .bundle-price').css('display','none');
//      $('.add-collection-bundle .inner .price-atc-button .save-price').css('display','none');
//    }
  
//   $('.single-bundle-count').html('You have '+ bundleCount +' products in your bundle')
// }  
  


// $(".added-product-block .add-image svg").on("click", function () {
//   var removeVariantId = $(this).attr('variant');
//   console.log('remove');

//   // Remove the variant from the getPrice array
//   getPrice = getPrice.filter(product => product.selectVariantId != removeVariantId);

//   // Locate the corresponding button in the collection and remove the "selected" class
//   var correspondingButton = $('.collection-block .products .addtocart-collection-bundle button[variant="' + removeVariantId + '"]');
  
//   if (correspondingButton.length) {
//     correspondingButton.removeClass("selected").text("Add To Box");
//   } else {
//     console.warn("No corresponding button found for variant:", removeVariantId);
//   }

//   // Hide the current image block and show the empty image
//   $(this).parents('.add-image').css('display', 'none');
//   $(this).parents('.add-image').siblings('.empty-image').css('display', 'inline-flex');

//   // Update the UI for the remaining products in the getPrice array

//   $(".added-product-block .product-item").removeClass('item-active');
  
//   $(".added-product-block .product-item").each(function (index) {
//     if (index < getPrice.length) {
//       // For active products
//       $(this).removeClass('item-active');
//       $(this).find('.add-image').css('display', 'block');
//       $(this).find('.add-image').siblings('.empty-image').css('display', 'none');
//       $(this).find('.add-image img').attr("src", getPrice[index].image_url);
//       $(this).find('.add-image svg').attr("variant", getPrice[index].selectVariantId);
//     } else {
//       // For empty slots
//       $(this).find('.add-image').css('display', 'none');
//       $(this).find('.empty-image').css('display', 'inline-flex');
//     }
//   });
  
//   $(".added-product-block .product-item").eq(getPrice.length).addClass('item-active');



//   var ProCount = $('#collection-bundle-product').attr('bundle-limit');

//     var SelectedProductCount = 0;
//     var AllSelectedProduct = $('.addtocart-collection-bundle .selected');
//     if (AllSelectedProduct.length > 0) {
//         SelectedProductCount = AllSelectedProduct.length;
//     } else {
//         SelectedProductCount = 0;
//     }



//     if(ProCount == SelectedProductCount) {
//      $(`.addtocart-collection-bundle .add-btn`).prop('disabled',true);
//      $(`.addtocart-collection-bundle .add-btn.selected`).prop('disabled',false);
//     } else {
//       $(`.addtocart-collection-bundle .add-btn`).prop('disabled',false);
//     }
 

//   checkLimit();
//   console.log(getPrice, 'getPrice-new');
// });



// // $(".added-product-block .add-image svg").on("click", function () {
// //   var removeVariantId = $(this).attr('variant');
// //   console.log('remove');

// //   // Filter out the removed variant from the getPrice array
// //   getPrice = getPrice.filter(product => product.selectVariantId != removeVariantId);

// //   // Hide the current image block and show the corresponding empty image block
// //   $(this).parents('.add-image').css('display', 'none');
// //   $(this).parents('.add-image').siblings('.empty-image').css('display', 'inline-flex');

// //   // Update the UI for remaining items in the getPrice array
// //   getPrice.forEach((item, index) => {
// //     var productItem = $(".added-product-block .product-item").eq(index);

// //     productItem.find('.add-image').css('display', 'block');
// //     productItem.find('.add-image').siblings('.empty-image').css('display', 'none'); // Hide empty image for active items
// //     productItem.find('.add-image img').attr("src", item.image_url);
// //     productItem.find('.add-image svg').attr("variant", item.selectVariantId);

// //     console.log(item, 'item--2');
// //   });

// //   console.log(getPrice, 'getPrice-new');
// // });



//   function selectedVariant(currentTag, variantId){
//     var variant= {};
//     $('#collection-bundle-product').prop('disabled',true);
//      jQuery.getJSON(window.Shopify.routes.root + 'products/'+$(currentTag).attr('product-handle')+'.js', function(product) {
//       $.each( product.variants, function( index, value ){
//         if(value.id == variantId) {
//           variant = value;
//         }
//       });

//        checkLimit();
//       // console.log(variant);
//     });
//   }


//   $("#collection-bundle-product-top").on("click", function() {
//     var updateProOnCart = document.querySelector('cart-drawer');
//     var sections = updateProOnCart.getSectionsToRender().map((section) => section.id);

//     var allVariant = [];
//     var dataApi = [];
//     var formData = {};

//     let items = [];
//     let selected_bundles = $('.addtocart-collection-bundle .selected');
//     for(let i = 0;i < selected_bundles.length;i++){
//       let temp = {};
//       let quantity = 1;
//       let variant_id = $(selected_bundles[i]).attr("variant");
//       console.log(variant_id + 'ID');
//       temp['id'] = variant_id;
//       temp['quantity'] = quantity;
//       items.push(temp);
//     }

//     formData = {'items': items, 'sections' : sections };
//     // console.log(formData);
//     addItemToCartColection(formData, updateProOnCart);
//   });


//   $("#collection-bundle-product").on("click", function() {
//     var updateProOnCart = document.querySelector('cart-drawer');
//     var sections = updateProOnCart.getSectionsToRender().map((section) => section.id);

//     var allVariant = [];
//     var dataApi = [];
//     var formData = {};

//     let items = [];
//     let selected_bundles = $('.addtocart-collection-bundle .selected');
//     for(let i = 0;i < selected_bundles.length;i++){
//       let temp = {};
//       let quantity = 1;
//       let variant_id = $(selected_bundles[i]).attr("variant");
//       console.log(variant_id + 'ID');
//       temp['id'] = variant_id;
//       temp['quantity'] = quantity;
//       items.push(temp);
//     }

//     formData = {'items': items, 'sections' : sections };
//     // console.log(formData);
//     addItemToCartColection(formData, updateProOnCart);
//   });

//   function addItemToCartColection(formData, updateProOnCart) {
//     jQuery.ajax({
//       type: 'POST',
//       url: '/cart/add.js',
//       data: formData,
//       dataType: 'json',
//       success: function(data, textStatus, xhr) {
//         addToCartSuccess(data, textStatus, xhr, updateProOnCart);
//       },
//       error: function(error) {
//         addToCartFail(error);
//       }
//     });
//   }


//   function addToCartSuccess(products, textstatus, msg, updateProOnCart) {
//     if(msg.status == 200 && msg.statusText == "success"){
//       // $('.cart-msg').html('<p class="cart-success" style="color:#56ad6a;">Products Successfully added to cart...</p>');
//       // For Default Cartdrawer
//         products['items'][0]['sections'] = products['sections'];
//         updateProOnCart.renderContents(products['items'][0]);// Update Product in cart
//         if (updateProOnCart && updateProOnCart.classList.contains('is-empty')) updateProOnCart.classList.remove('is-empty');

//       // For Cartdrawer App 
//         // window.SLIDECART_UPDATE();
//         // window.SLIDECART_OPEN();
//     }
//   }
  
//   function addToCartFail(products) {
//     console.log(products);
//     if(products.status == 422){
//       $('.cart-msg').html('<p class="cart-error" style="color: red;">'+products.responseJSON.description+'</p>');
//     }
//     if(products.status == 400){
//       $('.cart-msg').html('<p class="cart-error" style="color: red;">Add Products to Bundle...</p>');
//     }
//   }


//   if ($(window).width() < 750)
//     {
//       $('.added-product-block.desktop').remove();
//       $('.price-atc-button .total-price.desktop').remove();
//     }

//   if ($(window).width() > 749)
//     {
//       $('.added-product-block.mobile').remove();
//       $('.price-atc-button .total-price.mobile').remove();
//     }
  
     
// });











// $( document ).ready(function() {

//   $('.added-product-block .added-product .product-item:first-child').addClass('item-active');

//   var getQty = [];
//   var getPrice = [];

// $(".colection-product .add-btn").on("click", function() {
//     var variantId = $(this).attr('variant');
//     var image = $(this).attr('image-url');
//     // var quanty = $(this).attr('qty');
//     var currentTag = $(this);
//     $(currentTag).parents('.addtocart-collection-bundle').find('.alert-msg').html('<p class="loading">Loading...</p>');
//     selectedVariant(currentTag, variantId);


//   $(this).addClass("selected");
  
//     // if ($(this).text() == 'Add To Box') {
//     //     $(this).text('Remove Item');
//     //     // $(this).text('Added');
//     //     $(this).addClass("selected");
//     // } else {
//     //     $(this).text('Add To Box');
//     //     $(this).removeClass("selected");
        
//     //     // // Filter out the deselected item
//     //     getPrice = getPrice.filter((product) => {
//     //         return product.selectVariantId != variantId;
//     //     });


//     //    // Filter out the deselected item from getPrice
//     //     // getPrice = getPrice.filter(product => product.selectVariantId != variantId);
      
//     //     // Find the specific SVG element for this variant and trigger its click event
//     //     var removeTopBar = $('.added-product-block .add-image svg[variant="' + variantId + '"]');
        
//     //     if (removeTopBar.length) {
//     //       removeTopBar.trigger('click');
//     //     } else {
//     //       console.warn("No matching SVG element found for variant:", variantId);
//     //     }   

//     //     // console.log(getPrice, 'Updated getPrice after removing item');
//     // }

    


//   // Retrieve the current quantity count or initialize it to 0
//     var QtyCount = $(this).data("qty") || 0;

//     // Increment the count
//     QtyCount++;

//     // Update the data attribute and optionally a DOM attribute
//     $(this).data("qty", QtyCount); // Update the data storage
//     $(this).attr("qty", QtyCount); // Optional: Update the DOM attribute

//     // You can use QtyCount here if needed
//     console.log("Updated QtyCount-1:", QtyCount);

//   // console.log(quanty,'quanty');

    

//   var AllSelectedProductPrice = $(this).hasClass('selected') ? $(this).attr("price") : null;
  
//     if (AllSelectedProductPrice) {
//       getPrice.push({'selectVariantId': variantId, 'price': parseFloat(AllSelectedProductPrice), 'image_url': image, 'qty': QtyCount});
//     }

//   // Calculate the total price
//     var totalQty = getPrice.reduce((totalQty, product) => {
//         return totalQty + Math.round(product.qty);
//     }, 0);

//     console.log(totalQty,'totalQty');
  

//     var ProCount = $('#collection-bundle-product').attr('bundle-limit');

//     var SelectedProductCount = 0;
//     var AllSelectedProduct = $('.addtocart-collection-bundle .selected');
//     if (AllSelectedProduct.length > 0) {
//         SelectedProductCount = AllSelectedProduct.length;
//     } else {
//         SelectedProductCount = 0;
//     }



//     if(ProCount == SelectedProductCount) {
//        $(`.addtocart-collection-bundle .add-btn`).prop('disabled',true);
//        $(`.addtocart-collection-bundle .add-btn.selected`).prop('disabled',false);
//       } else {
//         $(`.addtocart-collection-bundle .add-btn`).prop('disabled',false);
//       }
  
  

//     // var AllSelectedProductPrice = $(this).hasClass('selected') ? $(this).attr("price") : null;

//     // if (AllSelectedProductPrice) {
//     //     getPrice.push({'selectVariantId': variantId, 'price': parseFloat(AllSelectedProductPrice), 'image_url': image, 'qty': qty});
//     // }
    
//     console.log(getPrice, 'getPrice');

//     // Calculate the total price
//     var totalprice = getPrice.reduce((total, product) => {
//         return total + Math.round(product.price);
//     }, 0);

//   console.log(totalprice,'totalprice');

//   $(".added-product-block .product-item").removeClass('item-active');
  
//   getPrice.forEach((item, index) => {
//     $(".added-product-block .product-item").eq(index).removeClass('item-active');
//     $(".added-product-block .product-item").eq(index).find('.add-image').css('display','block');
//     $(".added-product-block .product-item").eq(index).find('.add-image').siblings('.empty-image').css('display','none');
//     $(".added-product-block .product-item").eq(index).find('.add-image img').attr("src", item.image_url);
//     $(".added-product-block .product-item").eq(index).find('.add-image svg').attr("variant", item.selectVariantId);
//     // .attr( { title:"Test", alt:"Test2" } );
//     // console.log(item, 'item--1');
//   });

//   $(".added-product-block .product-item").eq(getPrice.length).addClass('item-active');

//   $('.selected-pro-price .bundle-price span').text(totalprice);
  
//   // Get the values as numbers
//   var selectedProPrice = parseFloat($('.selected-pro-price .bundle-price span').text()) || 0;
//   var stickyBarPrice = parseFloat($('.selected-pro-price .total-price span').text()) || 0;
  
//   // Calculate the savings and update the element
//   var savings = selectedProPrice - stickyBarPrice;
//   $('.save-price p span').text(savings); // Format to 2 decimal places if necessary

//     // Update selected product count in the DOM
//     $('.add-collection-bundle .selected-pro-count span.selected-product-count').text(SelectedProductCount);

// });
 
// });





$( document ).ready(function() {
   var allMatch = false;
  function getCartData() {
    jQuery.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(data) {
        compareVariantsAndToggleButton(data)
        const hasByob = data.items.some(item => item['properties']['_byob'] !== undefined);
        // If hasByob is true or there are no items in the cart, disable the buttons
        $('#collection-bundle-product-top, #collection-bundle-product').prop('disabled', hasByob || !data.items.length);
        $('#collection-bundle-product-top, #collection-bundle-product').text('Added in Cart');
      },
      error: function(error) {
        // handle error if needed
      }
    });
  }

  getCartData()
  
  function compareVariantsAndToggleButton(cartData) {
    var cart_items = cartData['items'];
    // Compare variant IDs from getPrice and cart_items
    if(getPrice.length && cart_items.length){
       allMatch = getPrice.every(function(priceItem) {
        return cart_items.some(function(cartItem) {
          return priceItem.selectVariantId == cartItem.id;
        });
      });
      console.log(cart_items,"cart_items")
      console.log(allMatch, "allMatch");
      // If all variant IDs match, disable the button; else enable the button
      if (allMatch) {
        $('#collection-bundle-product-top, #collection-bundle-product').prop('disabled', true); // Disable button
      } else {
        $('#collection-bundle-product-top, #collection-bundle-product').prop('disabled', false); // Enable button
      }
    }
  }

  $('.added-product-block .added-product .product-item:first-child').addClass('item-active');
  
  var getPrice = [];
  var bundleLimit = $('#collection-bundle-product').attr('bundle-limit');
  var totalQty = 0;


$(".colection-product .add-btn").on("click", function() {
    var variantId = $(this).attr('variant');
    var image = $(this).attr('image-url');
    var currentTag = $(this);
    var currentProQty = $(this).attr('quantity');
  
    // selectedVariant(currentTag, variantId);

  // Retrieve the current quantity count or initialize it to 0
  // var QtyCount = $(this).data("qty") || 0;
  
  // Calculate the total price
  var AllSelectedProductPrice = $(this).attr("price");
  // checkVariantAvailability(variantId, currentProQty);

  if (totalQty < bundleLimit) {
    getPrice.push({'selectVariantId': variantId, 'price': parseFloat(AllSelectedProductPrice), 'image_url': image, 'qty': 1});
  }

  totalQty = calculateTotalQuantity(getPrice);

  console.log(getPrice,'getPrice');

  if (bundleLimit == totalQty && $(this).text() == 'Add To Box') {
    $(this).text('Remove Item');
    $(this).addClass("selected");
  } 
  else {
    console.log(totalQty,"tt")
    lastItem($(this))
    $(this).text('Add To Box');
    $(this).removeClass("selected");
  }
   
   if(bundleLimit == totalQty) {
     console.log(totalQty,"totalQty")
     $(`.addtocart-collection-bundle .add-btn`).prop('disabled',true);
     $(`.addtocart-collection-bundle .add-btn.selected`).prop('disabled',false);
    } else {
      $(`.addtocart-collection-bundle .add-btn`).prop('disabled',false);
    }


  // Calculate the total price
  var totalprice = getPrice.reduce((total, product) => {
      return total + Math.round(product.price);
  }, 0);

  $(".added-product-block .product-item").removeClass('item-active');
  
  getPrice.forEach((item, index) => {
    $(".added-product-block .product-item").eq(index).removeClass('item-active');
    $(".added-product-block .product-item").eq(index).find('.add-image').css('display','block');
    $(".added-product-block .product-item").eq(index).find('.add-image').siblings('.empty-image').css('display','none');
    $(".added-product-block .product-item").eq(index).find('.add-image img').attr("src", item.image_url);
    $(".added-product-block .product-item").eq(index).find('.add-image svg').attr("variant", item.selectVariantId);
    $(".added-product-block .product-item").eq(index).find('.add-image svg').attr({
      "variant": item.selectVariantId,
      "position": index
    });

  });

  $(".added-product-block .product-item").eq(getPrice.length).addClass('item-active');

  $('.selected-pro-price .bundle-price span').text(totalprice);
  
  // Get the values as numbers
  var selectedProPrice = parseFloat($('.selected-pro-price .bundle-price span').text()) || 0;
  var stickyBarPrice = parseFloat($('.selected-pro-price .total-price span').text()) || 0;
  
  // Calculate the savings and update the element
  var savings = selectedProPrice - stickyBarPrice;
  $('.save-price p span').text(savings); // Format to 2 decimal places if necessary

  // $('.add-collection-bundle .selected-pro-count span.selected-product-count').text(totalQty);
  checkLimit();
});

// Function to check variant availability and display appropriate message
function checkVariantAvailability(variantId, quantity) {
  // Check how many times the variant is in the getPrice array and sum its quantity

  const totalVariantQty = getPrice.reduce((totalQty, product) => {
      return product.selectVariantId == variantId ? totalQty + product.qty : totalQty;
  }, 0);

  // Check if the total quantity of the variant exceeds the available quantity
  if (totalVariantQty <= quantity) {
      console.log('No problem, variant is available.');
  } else {
      console.log('Sold out, variant exceeds available quantity.');
  }
  return totalVariantQty + currentProQty <= currentProQty; 
}

//Calculates the total quantity 
function calculateTotalQuantity(getPrice) {
  return getPrice.reduce((totalQty, product) => {
      return totalQty + Math.round(product.qty);
  }, 0);
}


// Remove the item at a specific position based on variant
function removeItemByVariantAndPosition(getPrice, removeVariantId, removePosition) {
  if (getPrice[removePosition]?.selectVariantId == removeVariantId) {
      getPrice.splice(removePosition, 1); 
  }
  return getPrice;  // Return the updated array
}

// Function to remove last occurrence of item by variant
function removeLastOccurrence(masterArray, removeVariantId) {
    let lastIndex = -1;
    // Loop through the array from the end to find the last occurrence
    for (let i = masterArray.length - 1; i >= 0; i--) {
      if (masterArray[i].selectVariantId === removeVariantId) {
          lastIndex = i;
          break;
      }
    }

    // If last occurrence is found, remove it
    if (lastIndex !== -1) {
        masterArray.splice(lastIndex, 1);  // Removes the last occurrence
    }

    return masterArray;  // Return the updated array
}  
  
// Update the UI for the remaining products in the getPrice array
function update_ui_after_remove(masterArray){
  $(".added-product-block .product-item").removeClass('item-active');
  $(".added-product-block .product-item").each(function (index) {
    if (index < masterArray.length) {
      // For active products
      $(this).removeClass('item-active');
      $(this).find('.add-image').css('display', 'block');
      $(this).find('.add-image').siblings('.empty-image').css('display', 'none');
      $(this).find('.add-image img').attr("src", getPrice[index].image_url);
      $(this).find('.add-image svg').attr("variant", getPrice[index].selectVariantId);
    } else {
      // For empty slots
      $(this).find('.add-image').css('display', 'none');
      $(this).find('.empty-image').css('display', 'inline-flex');
    }
  });
  $(".added-product-block .product-item").eq(getPrice.length).addClass('item-active');
}
  

function lastItem(currentElement) {
  if ($(currentElement).hasClass('selected')) {
    // Get the 'variant' attribute of the current element if it has 'selected' class
    var lastVariantId = $(currentElement).attr('variant');
    getPrice = removeLastOccurrence(getPrice, lastVariantId);
    // Update the UI for the remaining products in the getPrice array
    update_ui_after_remove(getPrice);
    checkLimit();
    
    totalQty = calculateTotalQuantity(getPrice);
    
    // console.log(getPrice, "Last Item Block")
  }
}

function checkLimit() {
   var checkCount = [];
   var recentQuantity = calculateTotalQuantity(getPrice);

  if(bundleLimit <= recentQuantity) {
    $('#collection-bundle-product-top').prop('disabled',false);
     $('#collection-bundle-product').prop('disabled',false);
     $('.add-collection-bundle .inner .price-atc-button .selected-pro-price .bundle-price').css('display','block');
   } else {
    $('#collection-bundle-product-top').prop('disabled',true);
     $('#collection-bundle-product').prop('disabled',true);
     $('.add-collection-bundle .inner .price-atc-button .selected-pro-price .bundle-price').css('display','none');
     $('.add-collection-bundle .inner .price-atc-button .save-price').css('display','none');
   }
}  


$(".added-product-block .add-image svg").on("click", function () {
  var removeVariantId = $(this).attr('variant');
  var variantPosition = $(this).attr('position');

  // Remove the variant from the getPrice array
  getPrice = removeItemByVariantAndPosition(getPrice, removeVariantId, variantPosition); // Removes the second item with this variant ID
  // console.log(getPrice, "Removed Updated Array")
  // Update Quantity When remove the variant from getPrice
  totalQty = getPrice.reduce((totalQty, product) => {
      return totalQty + Math.round(product.qty);
  }, 0);
  
  // Hide the current image block and show the empty image
  $(this).parents('.add-image').css('display', 'none');
  $(this).parents('.add-image').siblings('.empty-image').css('display', 'inline-flex');

  // Update the UI for the remaining products in the getPrice array
  update_ui_after_remove(getPrice)
  // console.log(getPrice, "From SVG Blcok");
  
    var SelectedProductCount = 0;
    var AllSelectedProduct = $('.addtocart-collection-bundle .selected');
    if (AllSelectedProduct.length > 0) {
        SelectedProductCount = AllSelectedProduct.length;
    } else {
        SelectedProductCount = 0;
    }

    if(bundleLimit == SelectedProductCount) {
     $(`.addtocart-collection-bundle .add-btn`).prop('disabled',true);
     $(`.addtocart-collection-bundle .add-btn.selected`).prop('disabled',false);
    } else {
      $(`.addtocart-collection-bundle .add-btn`).prop('disabled',false);
      $(`.addtocart-collection-bundle .add-btn`).prop('disabled',false);
      $(`.addtocart-collection-bundle .add-btn`).text('Add To Box');
    }
 

  checkLimit();
  // console.log(getPrice, 'getPrice-new');
});

  // function selectedVariant(currentTag, variantId){
  //   var variant= {};
  //   // $('#collection-bundle-product').prop('disabled',true);
  //    jQuery.getJSON(window.Shopify.routes.root + 'products/'+$(currentTag).attr('product-handle')+'.js', function(product) {
  //     $.each( product.variants, function( index, value ){
  //       if(value.id == variantId) {
  //         variant = value;
  //       }
  //     });

  //      checkLimit();
  //     // console.log(variant);
  //   });
  // }


//   $("#collection-bundle-product-top").on("click", function() {
//     var updateProOnCart = document.querySelector('cart-drawer');
//     var sections = updateProOnCart.getSectionsToRender().map((section) => section.id);

//     let items = [];
//     let selected_bundles = $('.addtocart-collection-bundle .selected');
//     selected_bundles.each(function () {
//         // Retrieve quantity and variant ID from the selected elements
//         let quantity = parseInt($(this).data("qty")) || 1; // Default to 1 if qty is not set
//         let variant_id = $(this).attr("variant");

//         // Push the item to the items array
//         items.push({
//             id: variant_id,
//             quantity: quantity
//         });
//     });

//     let formData = {
//         items: items,
//         sections: sections
//     };

//     console.log(formData, 'cart-items');
//     addItemToCartColection(formData, updateProOnCart);
// });


// $("#collection-bundle-product").on("click", function() {
//     var updateProOnCart = document.querySelector('cart-drawer');
//     var sections = updateProOnCart.getSectionsToRender().map((section) => section.id);

//     let items = [];
//     let selected_bundles = $('.addtocart-collection-bundle .selected');
//     selected_bundles.each(function () {
//         // Retrieve quantity and variant ID from the selected elements
//         let quantity = parseInt($(this).data("qty")) || 1; // Default to 1 if qty is not set
//         let variant_id = $(this).attr("variant");

//         // Push the item to the items array
//         items.push({
//             id: variant_id,
//             quantity: quantity
//         });
//     });

//     let formData = {
//         items: items,
//         sections: sections
//     };

//     console.log(formData, 'cart-items');
//     addItemToCartColection(formData, updateProOnCart);
// });



// $("#collection-bundle-product, #collection-bundle-product-top").on("click", function() {
//     var updateProOnCart = document.querySelector('cart-drawer');
//     var sections = updateProOnCart.getSectionsToRender().map((section) => section.id);

//     let items = [];
    
//     // Loop through all products with data-qty > 0
//     $('.addtocart-collection-bundle .add-btn').each(function () {
//         let quantity = parseInt($(this).data("qty")) || 0; // Default to 0 if qty is not set
//         if (quantity > 0) {
//             let variant_id = $(this).attr("variant");

//             // Push the item to the items array
//             items.push({
//                 id: variant_id,
//                 quantity: quantity
//             });
//         }
//     });

//     let formData = {
//         items: items,
//         sections: sections
//     };

//     console.log(formData, 'cart-items');
//     addItemToCartColection(formData, updateProOnCart);
// });




 $("#collection-bundle-product-top, #collection-bundle-product").on("click", function() {
    var updateProOnCart = document.querySelector('cart-drawer');
    var sections = updateProOnCart.getSectionsToRender().map((section) => section.id);

    var allVariant = [];
    var dataApi = [];
    var formData = {};

    let items = [];

    const properItems = getPrice.reduce((acc, item) => {
      const existing = acc.find(i => i.id === item.selectVariantId);
      if (existing) {
        existing.quantity += item.qty;
      } else {
        acc.push({ id: item.selectVariantId, quantity: item.qty,"properties": { "_byob": "any 3"} });
      }
      return acc;
    }, []);

    formData = {'items': properItems, 'sections' : sections };
    // console.log(formData);
    addItemToCartColection(formData, updateProOnCart);
  }); 

  
  

  function addItemToCartColection(formData, updateProOnCart) {
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: formData,
      dataType: 'json',
      success: function(data, textStatus, xhr) {
        addToCartSuccess(data, textStatus, xhr, updateProOnCart);
      },
      error: function(error) {
        addToCartFail(error);
      }
    });
  }


  function addToCartSuccess(products, textstatus, msg, updateProOnCart) {
    if(msg.status == 200 && msg.statusText == "success"){
      // $('.cart-msg').html('<p class="cart-success" style="color:#56ad6a;">Products Successfully added to cart...</p>');
      // For Default Cartdrawer
        products['items'][0]['sections'] = products['sections'];
        updateProOnCart.renderContents(products['items'][0]);// Update Product in cart
        if (updateProOnCart && updateProOnCart.classList.contains('is-empty')) updateProOnCart.classList.remove('is-empty');

        // For Cartdrawer App 
        // window.SLIDECART_UPDATE();
        // window.SLIDECART_OPEN();
      
        getCartData();
    }
  }
  
  function addToCartFail(products) {
    console.log(products);
    if(products.status == 422){
      $('.cart-msg').html('<p class="cart-error" style="color: red;">'+products.responseJSON.description+'</p>');
    }
    if(products.status == 400){
      $('.cart-msg').html('<p class="cart-error" style="color: red;">Add Products to Bundle...</p>');
    }
  }

// function getCartData() {
//   jQuery.ajax({
//     type: 'GET',  // GET request
//     url: '/cart.js',  // Appends data as query parameters
//     dataType: 'json',
//     success: function(data, textStatus, xhr) {
//       if(data['items'].length){

//         // const byobItem = data.items.some(function(item) {
//         //   return item._byob !== undefined; // Check if _byob exists for the item
//         // });
  
//         // if (byobItem) {
//         //    $('#collection-bundle-product-top').prop('disabled',true);
//         //    $('#collection-bundle-product').prop('disabled',true);
//         // } else {
//         //   $('#collection-bundle-product-top').prop('disabled',false);
//         //    $('#collection-bundle-product').prop('disabled',false);
//         // }  
//           $('#collection-bundle-product-top, #collection-bundle-product').prop('disabled',true);
//           $('#collection-bundle-product-top').text('Added in Cart');
//           $('#collection-bundle-product').text('Added in Cart');
//       }else{
//        $('#collection-bundle-product-top, #collection-bundle-product').prop('disabled',false);
//       }
//     },
//     error: function(error) {
//       // addToCartFail(error);
//     }
//   });
// }

  if ($(window).width() < 750)
    {
      $('.added-product-block.desktop').remove();
      $('.price-atc-button .total-price.desktop').remove();
    }

  if ($(window).width() > 749)
    {
      $('.added-product-block.mobile').remove();
      $('.price-atc-button .total-price.mobile').remove();
    }
  
     
});



// document.addEventListener("DOMContentLoaded", () => {
//   document.querySelectorAll("media-gallery").forEach((gallery) => {
//     const prevBtn = gallery.querySelector(".gallery-nav--prev");
//     const nextBtn = gallery.querySelector(".gallery-nav--next");

//     if (!prevBtn || !nextBtn || typeof gallery.setActiveMedia !== "function") return;

//     function getVisibleThumbs() {
//       return [...gallery.querySelectorAll(".thumbnail-list__item")]
//         .filter(item => {
//           return item.offsetParent !== null &&
//                  !item.classList.contains("thumbnail-list_item--variant") &&
//                  !item.classList.contains("thumbnail-list__item--variant");
//         });
//     }

//     let currentIndex = 0;

//     function updateButtons() {
//       const thumbs = getVisibleThumbs();
//       const lastIndex = thumbs.length - 1;

//       prevBtn.disabled = currentIndex <= 0;
//       nextBtn.disabled = currentIndex >= lastIndex;

//       prevBtn.classList.toggle("is-disabled", currentIndex < 1);
//       nextBtn.classList.toggle("is-disabled", currentIndex >= lastIndex);
//     }

//     function goTo(index) {
//       const thumbs = getVisibleThumbs();
//       const lastIndex = thumbs.length - 1;

//       if (index < 0 || index > lastIndex) return;

//       currentIndex = index;

//       const mediaId = thumbs[currentIndex].dataset.target;
//       gallery.setActiveMedia(mediaId, false);

//       updateButtons();
//     }

//     prevBtn.addEventListener("click", () => {
//       goTo(currentIndex - 1);
//     });

//     nextBtn.addEventListener("click", () => {
//       goTo(currentIndex + 1);
//     });

//     getVisibleThumbs().forEach((item, index) => {
//       item.addEventListener("click", () => {
//         currentIndex = index;
//         updateButtons();
//       });
//     });

//     updateButtons();
//   });
// });

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("media-gallery").forEach((gallery) => {
    const prevBtn = gallery.querySelector(".gallery-nav--prev");
    const nextBtn = gallery.querySelector(".gallery-nav--next");

    if (!prevBtn || !nextBtn) return;

    function getVisibleThumbs() {
      return [...gallery.querySelectorAll(".thumbnail-list__item")]
        .filter(item => item.offsetParent !== null);
    }

    let currentIndex = 0;

    function updateCurrentIndexFromActive() {
      const thumbs = getVisibleThumbs();

      const activeIndex = thumbs.findIndex(item =>
        item.querySelector("button[aria-current='true']")
      );

      if (activeIndex >= 0) {
        currentIndex = activeIndex;
      }
    }

    function updateButtons() {
      const thumbs = getVisibleThumbs();
      const lastIndex = thumbs.length - 1;

      prevBtn.disabled = currentIndex <= 0;
      nextBtn.disabled = currentIndex >= lastIndex;

      prevBtn.classList.toggle("is-disabled", currentIndex <= 0);
      nextBtn.classList.toggle("is-disabled", currentIndex >= lastIndex);
    }

    function goTo(index) {
      const thumbs = getVisibleThumbs();
      const lastIndex = thumbs.length - 1;

      if (index < 0 || index > lastIndex) return;

      currentIndex = index;

      const thumbBtn = thumbs[currentIndex].querySelector("button");
      if (thumbBtn) thumbBtn.click();

      setTimeout(() => {
        updateCurrentIndexFromActive();
        updateButtons();
      }, 150);
    }

    prevBtn.addEventListener("click", () => {
      updateCurrentIndexFromActive();
      goTo(currentIndex - 1);
    });

    nextBtn.addEventListener("click", () => {
      updateCurrentIndexFromActive();
      goTo(currentIndex + 1);
    });

    document.addEventListener("click", (event) => {
      const item = event.target.closest("media-gallery .thumbnail-list__item");
      if (!item || !gallery.contains(item)) return;

      setTimeout(() => {
        updateCurrentIndexFromActive();
        updateButtons();
      }, 150);
    });

    updateCurrentIndexFromActive();
    updateButtons();
  });
});